import { DesktopUpdateAvailabilityParams } from 'api/legacy-session/types';

export const DEFAULT_DESKTOP_AVAILABILITY: DesktopUpdateAvailabilityParams = {
  AreaID: '',
  AreaName: '',
  SelectedDate: '',
  ServiceOption: '0',
  StoreID: '0',
  FlexOptionID: '0',
  FlexFromDate: '1/1/0001 12:00:00 AM',
  FlexToDate: '1/1/0001 12:00:00 AM',
  FlexDiscount: '0',
  IsFlex: false,
  CurrentRecipientID: '0',
  ContactRecipientID: '0',
  DeliveryFeeDetailID: '0',
  ConfigDeliveryFeeCharges: '0',
  ConfigDeliveryDate: '1/1/0001 12:00:00 AM',
  IsCateringProductSelected: 'false',
  ArrangementGroupID: '5',
};
